/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_ButtonInputs */

const en_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync`)
};

const fr_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchroniser`)
};

const de_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisieren`)
};

const it_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizza`)
};

const ru_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизировать`)
};

const es_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar`)
};

const zh_cn2_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步`)
};

const ja_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期`)
};

const hi_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंक करें`)
};

const pt_pt2_offline_sync_button = /** @type {(inputs: Offline_Sync_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar`)
};

/**
* | output |
* | --- |
* | "Sync" |
*
* @param {Offline_Sync_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_button = /** @type {((inputs?: Offline_Sync_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_button(inputs)
	if (locale === "de") return de_offline_sync_button(inputs)
	if (locale === "it") return it_offline_sync_button(inputs)
	if (locale === "ru") return ru_offline_sync_button(inputs)
	if (locale === "es") return es_offline_sync_button(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_button(inputs)
	if (locale === "ja") return ja_offline_sync_button(inputs)
	if (locale === "hi") return hi_offline_sync_button(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_button(inputs)
	return en_offline_sync_button(inputs)
});